module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.cf4d60b.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Medium.woff
// module id = 452
// module chunks = 1